<template>
    <v-container class="pa-2" fluid grid-list-sm >                           
        <div v-for="(chapter, index) in info.chapterlist" v-bind:key="chapter.chapter_id" @click="populateChapter(chapter)">
            <v-card>
                <v-card-title>
                    <v-flex xs1 ><v-img :src="chapter.chapter_icon" width="40px" height="40px" alt=""></v-img></v-flex>
                    <v-flex xs3 ><span :style="getTranStyle(chapter.name)">{{getChapter(chapter.name)}}</span></v-flex>
                    <v-flex xs4 >{{chapter.lessons.length}}</v-flex>                        
                    <v-flex xs4 >
                        <v-icon @click="editChapter(chapter.chapter_id)">mdi-pencil</v-icon>
                        <v-icon @click="deleteChapter(chapter.chapter_id)">mdi-delete</v-icon>
                        <v-icon v-if="index > 0" @click="moveChapter(index, index-1)">mdi-arrow-up</v-icon>
                        <v-icon v-if="index < info.chapterlist.length-1" @click="moveChapter(index, index+1)">mdi-arrow-down</v-icon>
                    </v-flex>   
                </v-card-title >
                <v-card-text v-if="populated == chapter.chapter_id"> 
                    <v-layout row wrap v-for="(lesson, index2) in chapter.lessons" v-bind:key="lesson.lesson_id" >
                        <v-flex xs3 offset-1 @click="gotoLessonContent(lesson.lesson_id)" :style="getTranStyle(lesson.lesson)">
                            <v-layout justify-start>
                                {{index2+1}}. {{getLesson(lesson.lesson)}}
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>{{lesson.tasks}} / {{lesson.programs}}</v-flex>
                        <v-flex xs1>{{lesson.tasks_score}} / {{lesson.programs_score}}</v-flex>  
                        <v-flex xs2>
                                <v-icon small @click="$router.push({name:'lesson_admin_content', params: {id: lesson.lesson_id}}) ">mdi-launch</v-icon>
                                <v-icon small @click="editLesson(lesson.lesson_id)">mdi-pencil</v-icon>
                                <v-icon small @click="deleteLesson(lesson.lesson_id)">mdi-delete</v-icon>
                                <v-icon small v-if="index2 > 0"  @click="moveLesson(index, index2, index2-1)">mdi-arrow-up</v-icon>
                                <v-icon small v-if="index2 < chapter.lessons.length-1" @click="moveLesson(index, index2, index2+1)">mdi-arrow-down</v-icon>
                        </v-flex>                              
                    </v-layout>
                    <v-flex xs6>
                        <v-layout justify-center>
                             <v-icon size="medium" @click="addLesson()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-flex>
                </v-card-text>
            </v-card>
        </div>
        <v-card>
            <v-card-text>
                <v-layout justify-center>
                    <v-icon size="x-large" @click="addChapter()">mdi-plus-circle-outline</v-icon> 
                </v-layout>
            </v-card-text>  
        </v-card>
    </v-container>
</template>

<script>
import axios from '../../../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            info : [],
            populated: 0
        }
    },
    computed : 
        mapGetters([
                        'isAdmin'   

                    ])
    ,
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setBcChange',true)
            this.$store.commit('setFeedback', null)   
            //this.$store.dispatch('setActiveCourse',{id:chapter.chapter_id, name: chapter.name}) 
            // get category list
            axios.get('/course-preview/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.info = res.data 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        addChapter() {
            this.$router.push({name:'admin_chapter', params: {id: '0'}})        
        },
        editChapter(id) {
            this.$router.push({name:'admin_chapter', params: {id: id}})        
        },
        deleteChapter(id) {
            this.$store.commit('setFeedback', null)    
            // get list
            axios.get('/delete-chapter/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveChapter(p1, p2) {
            const data = {
                chapter_id1: this.info.chapterlist[p1].chapter_id,
                chapter_order1: this.info.chapterlist[p1].chapter_order,
                chapter_id2: this.info.chapterlist[p2].chapter_id,
                chapter_order2: this.info.chapterlist[p2].chapter_order
            }

            axios.post('/chapter-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },




        addLesson() {
            this.$router.push({name:'admin_lesson', params: {id: '0'}})        
        },
        editLesson(id) {
            this.$router.push({name:'admin_lesson', params: {id: id}})        
        },
        deleteLesson(id) {
            this.$store.commit('setFeedback', null)    
            // get list
            axios.get('/delete-lesson/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveLesson(chapter_index, p1, p2) {
            const data = {
                lesson_id1: this.info.chapterlist[chapter_index].lessons[p1].lesson_id,
                lesson_order1: this.info.chapterlist[chapter_index].lessons[p1].lesson_order,
                lesson_id2: this.info.chapterlist[chapter_index].lessons[p2].lesson_id,
                lesson_order2: this.info.chapterlist[chapter_index].lessons[p2].lesson_order,
            }

            axios.post('/lesson-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },
      populateChapter(chapter) {
          this.populated = chapter.chapter_id; 
          this.$store.dispatch('setActiveChapter',{id:chapter.chapter_id, name: chapter.name});
      },
      gotoLessonContent(_id)  {
          this.$router.push({name:'lesson_admin_content', params: {id: _id}})        
      },
      getChapter(txt) {
          if (txt.length > 1) return txt
          return '-- not translated chapter name --'
      },
      getLesson(txt) {
          if (txt.length > 1) return txt
          return '-- not translated lesson name --'
      },
      getTranStyle(txt){
       if (txt.length > 1) return "cursor:pointer;";
       return "cursor:pointer;color:silver";
      }

    }
    
}
</script>


<style>

</style>
